import * as Yup from "yup";
import { emailValidator } from "../../validations";
import { CONFIRM_PASSWORD_REQUIRED, FULLNAME_MAX_CHAR, FULLNAME_MAX_CHAR_MESSAGE, FULLNAME_MIN_CHAR, FULLNAME_MIN_CHAR_MESSAGE, FULLNAME_REQUIRED, MIN_CHAR_LENGTH, PASSWORD_MUST_MATCH, PASSWORD_REQUIRED, PASSWORD_STRENGTH } from "../../constants/messages";
import { PASSWORD_MIN_CHAR, PASSWORD_REGEX } from "../../constants";

export const CreateAccountSchema = Yup.object({
    fullName: Yup.string().min(FULLNAME_MIN_CHAR, FULLNAME_MIN_CHAR_MESSAGE).max(FULLNAME_MAX_CHAR,FULLNAME_MAX_CHAR_MESSAGE).required(FULLNAME_REQUIRED),
    email: emailValidator,
    password: Yup.string()
        .required(PASSWORD_REQUIRED)
        .min(PASSWORD_MIN_CHAR, MIN_CHAR_LENGTH)
        .transform((value: string) => value.trim())
        .matches(PASSWORD_REGEX, PASSWORD_STRENGTH),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), ""], PASSWORD_MUST_MATCH)
        .required(CONFIRM_PASSWORD_REQUIRED),
});